// src/components/Login/useLoginSubmit.ts
import { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { AuthorizeLoginToken, goToNextAuthStep } from "../actions/auth";
import { trackEvent } from "../services/eventTracker";
import { toErrorObjs } from "../services/formatter";
import { EVENTS } from "../constants/events";
import { LOCAL_STORAGE } from "../constants/enums";
import { useAppDispatch } from "../store/hooks";
import type { ErrorObj } from "../types/errors";
import type { LoginFormValues } from "../types/components/Login";

export const useLoginSubmit = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [errors, setErrors] = useState<ErrorObj[] | null>(null);

  const onSubmit = useCallback(
    async ({ username, rememberMe }: LoginFormValues): Promise<void> => {
      trackEvent(EVENTS.LOGIN.USERNAME_SUBMITTED);

      if (rememberMe) {
        localStorage.setItem(LOCAL_STORAGE.Username, username);
      } else {
        localStorage.removeItem(LOCAL_STORAGE.Username);
      }

      try {
        await dispatch((AuthorizeLoginToken as any)(username));
        dispatch(goToNextAuthStep(history));
      } catch (error: unknown) {
        setErrors(toErrorObjs(error));
      }
    },
    [dispatch, history]
  );

  return { onSubmit, errors };
};